import i18n from "~/i18n";

export const translateBackendMessage = (message) => {
  switch (message) {
    case "Job type not available.":
      return i18n.t("Job type not available") + ".";
    default:
      return message;
  }
};
